const en = {
  // Navigation
  dashboard: "Dashboard", messages: "Messages", settings: "Settings", calendar: "Calendar",
  search: "Search", favorites: "Favorites", resourceHub: "Resource Hub", logout: "Logout", admin: "Admin",
  // Dashboard
  quickActions: "Quick Actions", findProviders: "Find Providers, Jobs, Parents, Camps & Programs",
  upcomingEvents: "Upcoming Events", addEvent: "Add Event", upgrade: "Upgrade",
  pendingBookings: "Pending Bookings", completeProfile: "Complete your profile",
  // Auth
  signIn: "Sign In", signUp: "Sign Up", email: "Email", password: "Password", name: "Name",
  forgotPassword: "Forgot your password?", createAccount: "Create Account",
  alreadyHaveAccount: "Already have an account?", dontHaveAccount: "Don't have an account?",
  sendResetLink: "Send Reset Link", resetPassword: "Reset Password",
  newPasswordPlaceholder: "Min 8 chars, upper, lower, number, special",
  passwordPolicy: "8+ characters, uppercase, lowercase, number, special character",
  checkYourEmail: "Check your email", passwordReset: "Password Reset!",
  invalidResetLink: "Invalid Reset Link", backToLogin: "Back to Login",
  // Profile
  children: "Children", childrenLookingForCare: "children looking for childcare",
  contactInfo: "Contact Info", availability: "Availability Calendar",
  reviews: "Reviews", noReviews: "No reviews yet", writeReview: "Write a Review",
  needsPreferences: "Needs & Preferences", getDirections: "Get Directions",
  viewProfile: "View Profile", peopleWhoSavedMe: "People Who Saved Me",
  savedFavorites: "Saved Favorites", noFavorites: "No favorites yet", browseNow: "Browse Now",
  // Bookings
  reserveDropIn: "Reserve Drop-In Spot", spotsAvailable: "spots available", bookNow: "Book",
  accept: "Accept", decline: "Decline", review: "Review", sendMessage: "Send Message",
  sendDeclinedMessage: "Send Declined Message", skip: "Skip",
  bookingAccepted: "Booking request sent! The provider will review and respond.",
  report: "Report", reportEvent: "Report this event as inappropriate?",
  reported: "Reported — under review",
  // Calendar
  operationsCalendar: "Operations Calendar", eventsCalendar: "Events Calendar",
  shareCalendar: "Share Calendar", syncCalendar: "Sync", showToday: "Show Today",
  batchDelete: "Batch Delete",
  // Messaging
  directMessages: "Direct", groups: "Groups", newMessage: "Type a message...",
  send: "Send", shareChildInfo: "Share Child Info", requestChildInfo: "Request Child Info",
  infoShared: "Info Shared",
  // Resources
  resources: "Resources", formsAndDocuments: "Forms & Documents",
  suggestResource: "Suggest Resource", viewPdf: "View PDF", viewResource: "View Resource",
  browseCollection: "Browse Collection", region: "Region", formType: "Type",
  allRegions: "All Regions", allTypes: "All Types",
  pdfResources: "PDF Resources", coloringPages: "Coloring Pages",
  // Contact
  contactUs: "Contact Us", faqs: "FAQs", privacyTerms: "Privacy & Terms",
  helpSupport: "Help & Support", bugReport: "Bug Report", suggestion: "Suggestion",
  other: "Other", sendMessageBtn: "Send Message", messageSent: "Message Sent!",
  sendUsMessage: "Send us a message", reachUsDirectly: "You can also reach us directly:",
  topic: "Topic", message: "Message", yourName: "Your Name", howCanWeHelp: "How can we help?",
  // Common
  save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", create: "Create",
  submit: "Submit", confirm: "Confirm", loading: "Loading...", noResults: "No results found",
  moreInfo: "More info", all: "All", active: "Active", pending: "Pending",
  approved: "Approved", back: "Back", sponsored: "Sponsored",
  // Settings
  generalInfo: "General Info", changePassword: "Change Password",
  currentPassword: "Current Password", newPassword: "New Password",
  confirmPassword: "Confirm Password", downloadMyData: "Download My Data",
  requestDeletion: "Delete My Account", deleteMyAccount: "Delete My Account",
  requiredField: "Indicates a required field", saveUpdates: "Save Updates",
  // Admin
  adminPanel: "Admin Panel", overview: "Overview", users: "Users", content: "Content",
  financials: "Financials", system: "System", security: "Security", auditLog: "Audit Log", ads: "Ads",
  // Landing
  heroTitle: "Find Trusted Childcare Near You",
  heroSubtitle: "Connect with verified daycares, nannies, babysitters, and camps in your neighborhood.",
  getStarted: "Get Started", getStartedFree: "Get Started Free",
  browseProviders: "Browse Providers", whyUs: "Why ChildCareConnections & ElderCareConnections",
  joinThousands: "Join thousands of families and providers already using ChildCareConnections & ElderCareConnections.",
  trustedProviders: "Trusted Providers",
  trustedProvidersDesc: "Verified profiles with reviews, certifications, and detailed information.",
  easyBooking: "Easy Booking",
  easyBookingDesc: "Book drop-in spots, schedule visits, and manage everything in one place.",
  safeSecure: "Safe & Secure",
  safeSecureDesc: "Your children's information is private and shared only with your consent.",
  stayConnected: "Stay Connected",
  stayConnectedDesc: "Direct messaging, group chats, and real-time notifications.",
  readyToFind: "Ready to Find the Perfect Childcare?",
  // Search
  searchProviders: "Search Providers", mapView: "Map", listView: "List",
  providers: "Providers", workers: "Workers", parents: "Parents",
  camps: "Camps & Programs", neighborhoods: "Neighborhoods", city: "City",
  // FAQ
  faqTitle: "Frequently Asked Questions", faqSubtitle: "Find answers to common questions",
  searchFaqs: "Search FAQs...", contactWithQuestion: "Contact us with your question",
  // Privacy
  privacyPolicy: "Privacy Policy", termsOfService: "Terms of Service",
  // Subscription
  subscriptionPlans: "Subscription Plans", noteFromUs: "A Note From Us",
  yourPlan: "Your Plan", perMonth: "/month",
  // Favorites
  peopleWhoFavoritedMe: "People Who Saved Me", noOneYet: "No one has saved you as a favorite yet",
  // Forgot Password
  forgotPasswordTitle: "Forgot Password?",
  forgotPasswordSubtitle: "Enter your email and we'll send you a reset link",
  emailAddress: "Email Address", sending: "Sending...",
};
export default en;
